
import React, {Component} from 'react';
import PrintPreview from '../PrintPreview'
import ReportStore from 'stores/ReportStore'

const DEFAULT_ROW = 20
const DEFAULT_NEW_ROW = 0
class PrintReportStockCardVolume extends Component {

  constructor(...args){
    super(...args)

    this.state = ({
      data:{dataFormat:[],data:[]},
      report_title:'กำลังดึงข้อมูล..'
    })

    var cssPagedMedia = (function() {
        var style = document.createElement('style');
        document.head.appendChild(style);
        return function (rule) {
            style.innerHTML = rule;
        };
    }());
  
    cssPagedMedia.size = function(size) {
        cssPagedMedia('@page {size: ' + size + '}');
    };
    cssPagedMedia.size('portrait');
  }

  componentDidMount(){
    this.loadData()
  }

  loadData() {
    ReportStore.loadReportStockCardVolume(this.props.year, this.props.month, this.props.day, 0, '', (result) => {
      let check_date = []
      let dataFormat = []
      var id = []
      var itemnum = []
      var added_date = []
      var bill_type = []
      var in_quantity = []
      var out_quantity = []
      var balance_quantity = []
      var sum_in_quantity = 0
      var sum_out_quantity = 0
      var sum_balance_quantity = 0

      for (var i=0;i<result.data.length;i++) {
        if (check_date.indexOf(result.data[i].description)===-1) {
          check_date.push(result.data[i].description)
        }
      }

      for (var ii=0;ii<check_date.length;ii++) {
        for (var j=0;j<result.data.length;j++) {
          if (check_date[ii]===result.data[j].description) {
            id.push(result.data[j].ref_bill_no)
            itemnum.push(result.data[j].itemnum)
            added_date.push(result.data[j].added_date.substr(0,10))
            bill_type.push(result.data[j].bill_type)
            in_quantity.push(result.data[j].in_quantity===undefined?0:result.data[j].in_quantity)
            out_quantity.push(result.data[j].out_quantity===undefined?0:result.data[j].out_quantity)
            balance_quantity.push(result.data[j].balance_quantity)
            sum_in_quantity = (sum_in_quantity*1) + ((result.data[j].in_quantity===undefined?0:result.data[j].in_quantity)*1)
            sum_out_quantity = (sum_out_quantity*1) + ((result.data[j].out_quantity===undefined?0:result.data[j].out_quantity)*1)
            sum_balance_quantity = (sum_balance_quantity*1) + (result.data[j].balance_quantity*1)
          }
        }
        dataFormat.push({
          description: check_date[ii],
          meta: {
            id: id,
            itemnum: itemnum,
            added_date: added_date,
            bill_type: bill_type,
            in_quantity: in_quantity,
            out_quantity: out_quantity,
            balance_quantity: balance_quantity
          },
          sum_in_quantity: sum_in_quantity,
          sum_out_quantity: sum_out_quantity,
          sum_balance_quantity: sum_balance_quantity 
        })

        id = []
        itemnum = []
        added_date = []
        bill_type = []
        in_quantity = []
        out_quantity = []
        balance_quantity = []
        sum_in_quantity = 0
        sum_out_quantity = 0
        sum_balance_quantity = 0
      }

      let {data} = this.state
      data.dataFormat = this.getPagination(dataFormat)
      data.data = dataFormat
      this.setState({data:data,report_title:'ไม่พบข้อมูล'})
    })
  }

  getPagination(data) {
    let allData = []
    let newData = []
    let partData = {}
    let _id = []
    let _added_date = []
    let _bill_type = []
    let _in_quantity = []
    let _out_quantity = []
    let _balance_quantity = []
    let checkRow = 0
    
    data.forEach(function(item,index) {
      item.meta.id.forEach(function(items,indexs) {
        if (checkRow<DEFAULT_ROW) {
          _id.push(items)
          _added_date.push(item.meta.added_date[indexs])
          _bill_type.push(item.meta.bill_type[indexs])
          _in_quantity.push(item.meta.in_quantity[indexs])
          _out_quantity.push(item.meta.out_quantity[indexs])
          _balance_quantity.push(item.meta.balance_quantity[indexs])
          checkRow++
        }
        if (item.meta.id.length-1===indexs||checkRow===DEFAULT_ROW-1) {
          let sum_row = true
          if (item.meta.id.length-1!==indexs&&checkRow===DEFAULT_ROW-1)
            sum_row = false

          partData = {
            sum_row:sum_row,
            description:item.description,
            meta: {
              id:_id,
              added_date:_added_date,
              bill_type:_bill_type,
              in_quantity:_in_quantity,
              out_quantity:_out_quantity,
              balance_quantity:_balance_quantity
            },  
            sum_in_quantity:item.sum_in_quantity,
            sum_out_quantity:item.sum_out_quantity,
            sum_balance_quantity:item.sum_balance_quantity
          }

          newData.push(partData)
          partData = {}
          _id = []
          _added_date = []
          _bill_type = []
          _in_quantity = []
          _out_quantity = []
          _balance_quantity = []
        }
      
        if ((checkRow===DEFAULT_ROW-1)||(data.length-1===index&&item.meta.id.length-1===indexs)) {
          allData.push({
            dataList:newData
          })
          newData = []
          checkRow = DEFAULT_NEW_ROW
        }
      })
    })
    return allData
  }

  getNumberFormat(val) {
    if (val!==''&&val!==null&&val!==undefined&&!isNaN(val)) {
      return parseFloat(val).toLocaleString(undefined, {maximumFractionDigits: 2}) 
    }
    return val
  }

  renderRowSummary() {
    let {data} = this.state
    let sum = 0
    data.data.forEach(function(item,index) {
      sum += parseFloat(item.sum_balance_quantity)
    })

    return(
      <tr>
        <td colSpan={3}></td>
        <td className='bd-sum' colSpan={3}>ยอดรวมสุทธิ</td>
        <td className='bd-sum text-center'>{this.getNumberFormat(sum)}</td>
      </tr>
    )
  }

  renderRowData(data,_index) {
    return(
      data.dataList.map((item,index) => {
        return(
          <tr key={index}>
            <td className='text-left'>
              <div className="bd-date" style={{width:'300px',whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis'}}><b>{item.description}</b></div>
              {
                item.meta.added_date.map((added_date, index) => {
                  return(
                    <div key={index}>
                      <div>{index+1}. {added_date}</div>
                    </div>
                  )
                })  
              }
            </td>
            <td className='text-center'>
              <div className="bd-date"><br/></div>
              {
                item.meta.id.map((id, index) => {
                  return(
                    <div key={index}>
                      <div>{id===''||id===undefined?'-':id}</div>
                    </div>
                  )
                })  
              }
            </td>
            <td className='text-center'>
              <div className="bd-date"><br/></div>
              {
                item.meta.bill_type.map((bill_type, index) => {
                  return(
                    <div key={index}>
                      <div>{bill_type===''||bill_type===undefined?'-':bill_type}</div>
                    </div>
                  )
                })  
              }
            </td>
            <td>
              <div className="bd-date"><br/></div>
              {
                item.meta.id.map((id, index) => {
                  let bd_sum = ''
                  if (index===item.meta.id.length-1&&item.sum_row)
                    bd_sum = 'bd-sum'

                  return(
                    <div key={index} className={bd_sum}>
                      <div><br/></div>
                    </div>
                  )
                })
              }
              <div className="bd-sum" style={{display:item.sum_row?'':'none'}}><b>รวม/วัน</b></div>
            </td>
            <td className='text-center'>
              <div className="bd-date"><br/></div>
              {
                item.meta.in_quantity.map((in_quantity, index) => {
                  let bd_sum = ''
                  if (index===item.meta.in_quantity.length-1&&item.sum_row)
                    bd_sum = 'bd-sum'

                  return(
                    <div key={index} className={bd_sum}>
                      <div className='text-center'>{this.getNumberFormat(in_quantity)}</div>
                    </div>
                  )
                })
              }
              <div className="bd-sum text-center" style={{display:item.sum_row?'':'none'}}>{this.getNumberFormat(item.sum_in_quantity)}</div>
            </td>
            <td className='text-center'>
              <div className="bd-date"><br/></div>
              {
                item.meta.out_quantity.map((out_quantity, index) => {
                  let bd_sum = ''
                  if (index===item.meta.out_quantity.length-1&&item.sum_row)
                    bd_sum = 'bd-sum'

                  return(
                    <div key={index} className={bd_sum}>
                      <div className='text-center'>{this.getNumberFormat(out_quantity)}</div>
                    </div>
                  )
                })
              }
              <div className="bd-sum text-center" style={{display:item.sum_row?'':'none'}}>{this.getNumberFormat(item.sum_out_quantity)}</div>
            </td>
            <td className='text-center'>
              <div className="bd-date"><br/></div>
              {
                item.meta.balance_quantity.map((balance_quantity, index) => {
                  let bd_sum = ''
                  if (index===item.meta.balance_quantity.length-1&&item.sum_row)
                    bd_sum = 'bd-sum'

                  return(
                    <div key={index} className={bd_sum}>
                      <div className='text-center'>{this.getNumberFormat(balance_quantity)}</div>
                    </div>
                  )
                })
              }
              <div className="bd-sum text-center" style={{display:item.sum_row?'':'none'}}>{this.getNumberFormat(item.sum_balance_quantity)}</div>
            </td>
          </tr>
        )
      })
    )
  }

  renderTable(data,index,length) {
    return(
        <table className='table table-print-profit'>
          <tbody>
            <tr>
              <td style={{width:"300px"}} className="text-left"></td>
              <td style={{width:"100px"}} className="text-center">เลขที่บิล</td>
              <td style={{width:"80px"}} className="text-center">ประเภทบิล</td>
              <td style={{width:"100px"}}></td>
              <td style={{width:"100px"}} className="text-center">{'จำนวนเข้า'}</td>
              <td style={{width:"100px"}} className="text-center">{'จำนวนออก'}</td>
              <td style={{width:"100px"}} className="text-center">{'คงเหลือ'}</td>
            </tr>
            {this.renderRowData(data,index)}  
            {index===length?this.renderRowSummary():''}
          </tbody>
        </table>
    )
  }

  renderComponentPage(data,index,length) {
    return(
            <div className='font-print' key={index}>
                <header className="text-center">
                    <h2>{this.props.title}</h2>
                </header>
                <div>
                {this.renderTable(data,index,length)}
                </div>
            </div>
    )
  }

  renderNoData() {
    return(
          <div className='font-print'>
            <header className="text-center">
              <h2>{this.state.report_title}</h2>
            </header>
          </div>
    )
  }

  render(){
    let {data} = this.state
    if (data.data.length===0) {
      return(
        <div>
          <PrintPreview
            leftBarTitle={this.props.title}
          >
            {this.renderNoData()}
          </PrintPreview>
        </div>
      )
    } else {
      return(
        <div>
          <PrintPreview
            leftBarTitle={this.props.title}
          >
            {
              data.dataFormat.map((item,index) => {
                return(
                  this.renderComponentPage(item,index,data.dataFormat.length-1)
                )
              })
            }
          </PrintPreview>
        </div>
      )
    }
  }
}

PrintReportStockCardVolume.defaultProps = {
    title:'ตารางรายงานความเคลื่อนไหวของสต็อกของเหลว (Stock Card Volume)'
}

export default PrintReportStockCardVolume;


// WEBPACK FOOTER //
// ./src/view/print/material/PrintReportStockCardVolume.js